import React, { useEffect, useState } from "react";
import { Box, Button,  TextField } from "@mui/material";
import { DtDialog } from "../../../../components/ui/dialog";
import { FixedSizeList, ListChildComponentProps } from "react-window";
import { List, ListItem, ListItemText } from "@mui/material";

interface DocumentLookupProps {
  open: boolean;
  closeFxtn: () => void;
  documentList: Array<string>;
  itemSelected: (item: string) => void;
}

const DocumentLookup: React.FC<DocumentLookupProps> = ({
  open,
  closeFxtn,
  documentList,
  itemSelected
}) => {
  const [filteredList, setFilteredList] = useState(Array.from(new Set(documentList)));
  const [filterText, setFilterText] = useState("");
  const [selectedItem, setSelectedItem] = useState("");

  useEffect(() => {

    if (filterText !== "") {
      setFilteredList(documentList.filter(function (str) { return str.toLowerCase().includes(filterText.toLowerCase()); }));
    }
    else {
      setFilteredList(documentList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterText]);

  if (documentList == null) {
    return <></>;
  }

  const saveChanges = () => {
    if (itemSelected != null) {
      itemSelected(selectedItem);
    }
    setFilterText("");
  };

  return (
    <DtDialog
      title="Encompass Document Lookup"
      open={open}
      onClose={closeFxtn}
      fullWidth
      maxWidth="md"
      actions={
        <>
          <Button size="small" onClick={closeFxtn}>Cancel</Button>
          <Button size="small" variant="contained" onClick={saveChanges}>Apply</Button>
        </>
      }
      sx={{content: {pt: 1}}}
    >
        <Box sx={{
          position: 'sticky',
          background: "#fff",
          top: 0,
          zIndex: 2,
          borderRadius: 1,
        }}>
          <TextField
            label="Search/Filter"
            variant="outlined"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            size="small"
            fullWidth
          />
        </Box>
          <List disablePadding>
            <FixedSizeList
              height={380}
              itemCount={filteredList.length}
              itemSize={40}
              width="100%"
              itemData={{
                filteredList,
                selectedItem,
                setSelectedItem,
              }}
            >
              {({ index, style, data }: ListChildComponentProps) => {
                const opt = data.filteredList[index];
                return (
                  <ListItem
                    button
                    style={style}
                    selected={opt === data.selectedItem}
                    onClick={() => data.setSelectedItem(opt)}
                    key={index}
                    dense
                  >
                    <ListItemText primary={opt} />
                  </ListItem>
                );
              }}
            </FixedSizeList>
          </List>
    </DtDialog>
  );
};

export default DocumentLookup;